import HomeApplication from './HomeApplication';

export default HomeApplication;
